// extracted by mini-css-extract-plugin
export default {"box":"notificationDisciplines_box__BNQ+h","title":"notificationDisciplines_title__UZG1p","list":"notificationDisciplines_list__Efjcn","item":"notificationDisciplines_item__L+l8N"};